import {getRandomColor} from "../../../utils/GetRandomColor";
import {MathJax, MathJaxContext} from "better-react-mathjax";

export default function Algebra() {
    const imgStyle = {
        backgroundColor: "#E9E8E6",
        border: `5px solid ${getRandomColor()}`,
    }

    const altTextStyle = {
        marginLeft: "auto",
        marginRight: "auto",
        display: "block",
        textAlign: "center",
        marginTop: "-10px",
        fontStyle: "italic",
    }

    const mathJaxConfig = {
        loader: {load: ["[tex]/html"]},
        tex: {
            packages: {"[+]": ["html"]},
            inlineMath: [["$", "$"], ["\\(", "\\)"]],
            displayMath: [["$$", "$$"], ["\\[", "\\]"]]
        }
    }

    return (
        <MathJaxContext config={mathJaxConfig}>
            <div className={"blog-body"}>
            <h2>Algebra</h2>
            <p>
                Counting things has been a part of our lives since the beginning of the human era (Garding
                & Tambour, 2012). Therefore, it is not surprising that algebra is a part of computer
                programming, that is, machine learning.
                Vectors, matrices, and tensors are used for
                computations, and these structures are often called arrays in programming.
            </p>

            <h3>Kernels</h3>
            <p>
                Algebra is one of the fundamental mathematical topics of image processing. Actually, images in
                digital media are multidimensional arrays. In order for image processing algorithms to learn,
                different types of features must be obtained from the images. Matrices that extract features
                from an
                image by computing weighted sums are called kernels. An example of a kernel used for edge
                detection
                is given below.
            </p>

            <MathJax>{'\\begin{align} \nA=\\left[\\begin{array}{rrr}\n-1 & -1 & -1 \\\\\n-1 & 8 & -1 \\\\\n-1 & -1 & -1\n\\end{array}\\right]\n\\end{align}'}</MathJax>

            <p>
                Consider an image given as
            </p>

            <MathJax>{'\\begin{align} \nB=\\left[\\begin{array}{rrr}\n2 & 6 & 3 \\\\\n2 & 2 & 4 \\\\\n7 & 1 & 1\n\\end{array}\\right]\n\\end{align}'}</MathJax>

            <p>
                The formula for the weighted sum is
            </p>

            <MathJax>{'\\begin{align} \n\\sum_{i}{} \\sum_{j}{} a_{ij} b_{ij}\n\\end{align}'}</MathJax>

            <p>
                And the weighted sum obtained from the image is
            </p>

            <MathJax>{'\\begin{align}\n&=((-1)\\cdot 2 + (-1) \\cdot 6 + (-1) \\cdot 3) \\\\\n&+((-1) \\cdot 2 + 8 \\cdot 2 + (-1) \\cdot 4) \\\\\n&+((-1) \\cdot 7 + (-1) \\cdot 1 + (-1) \\cdot 1) \\\\\n&=-10\n\\end{align}'}</MathJax>

            <h3>Tensors</h3>
            <p>
                Tensor is a general mathematical term for arrays. In fact, vectors and matrices are tensors
                with one and two dimensions (Kan, 2021). However, not every matrix is considered a tensor
                because
                tensors are considered dynamic objects (Steinke, 2017)
            </p>
        </div>
        </MathJaxContext>
    )
}